import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as insightsAPI from '@debbie/cortex/dist/api/insights.js';
import { c } from '@debbie/cortex/dist/index.js';
import { useCaseFilter } from '@debbie/cortex/dist/insights/caseFilter.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../utils/errors.js';
import { PlaceholderLoader } from '..//index.js';
import ExternalLink from '../Icons/ExternalLink.js';
const CaseFilterQueue = (props) => {
    const caseFilter = useCaseFilter();
    const lang = useSelector((s) => s.lang);
    const openCaseQueue = useMutation(() => insightsAPI.getCaseFilterQueue({
        ...caseFilter,
        ...props.appendToCaseFilter,
    }), {
        onSuccess: (caseQueue) => {
            c.redirect.redirect(`/cases/${caseQueue.join(',')}`);
        },
        onError: (err) => errorNotification(lang, err, 'any', lang.errorEntities.case),
    });
    return openCaseQueue.isLoading ? (React.createElement(PlaceholderLoader, { width: "16px", height: "15px", inline: true })) : (React.createElement(ExternalLink, { style: { margin: '0.2em 0 -0.2em', cursor: 'pointer' }, onClick: () => openCaseQueue.mutate(), id: "ui-test-5e51e31e" }));
};
export default CaseFilterQueue;
//# sourceMappingURL=CaseFilterQueue.js.map